<label class="radioButton-wrapper" [ngClass]="{'disabled': disabled}">
    {{itemLabel}}
    <input type="radio" name="{{itemName}}" [disabled]="disabled"  [value]="value" [checked]="checked">
    <span class="checkmark"></span>
</label> 